import { DateTimePicker, DateTimePickerProps, MobileDateTimePicker, MobileDateTimePickerProps } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useScreenSize } from "src/hooks/useScreenSize";
import { styledCalendarIcon } from "src/components/inputs/date-picker/StyledCalendarIcon";
import updateLocale from "dayjs/plugin/updateLocale";
import { LocaleKey } from "src/components/monitoring/senec-time-frame-selection/TimeFrameContext";
import "dayjs/locale/de";
import "dayjs/locale/en";
import "dayjs/locale/it";

dayjs.extend(updateLocale);

type SenecDateTimePickerProps = MobileDateTimePickerProps<Dayjs> &
    DateTimePickerProps<Dayjs> & {
        "data-testid"?: string;
        localeKey?: LocaleKey;
    };

export const SenecDateTimePicker = ({
    localeKey,
    "data-testid": dataTestId = "datepicker",
    ...rest
}: SenecDateTimePickerProps) => {
    const { isMobile } = useScreenSize();

    if (localeKey) {
        dayjs.updateLocale(localeKey, {
            weekStart: localeKey === "en" ? 0 : 1,
        });
    }

    const commonProps = {
        disableFuture: true,
        ampm: false,
    };
    const theme = useTheme();

    return (
        <ThemeProvider theme={theme}>
            {isMobile ? (
                <MobileDateTimePicker
                    slotProps={{
                        textField: {
                            inputProps: {
                                "data-testid": dataTestId,
                            },
                        },
                    }}
                    {...commonProps}
                    {...rest}
                    sx={{
                        width: "190px",
                        ...(rest.sx ?? {}),
                    }}
                />
            ) : (
                <DateTimePicker
                    slotProps={{
                        textField: {
                            inputProps: {
                                "data-testid": dataTestId,
                            },
                        },
                    }}
                    slots={{ openPickerIcon: styledCalendarIcon }}
                    {...commonProps}
                    {...rest}
                    sx={{ width: "220px", "&:input": { fontSize: "5px" }, ...(rest.sx ?? {}) }}
                />
            )}
        </ThemeProvider>
    );
};
